import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {
  GeneralUserData,
  UserHealthRecord,
  IdentityDetails,
  UserRoleType,
  SchoolUserTypeDetail,
  SubjectsAllocation,
  StaffMemberClass,
  PagedResult
} from '../../_models';
import { ParentDetails } from './../../_models/users/parent-details';
import { ContactDetails } from './../../_models/users/contact-details';
import { SkillsSocialDetails } from './../../_models/users/skills-social-details';
import { PersonalInformation } from './../../_models/users/personal-information';
import { AcademicDetails } from '../../_models/users/academic-detail';
import { environment } from '../../../environments/environment';
import { UserRelation } from 'src/app/_models';
import { UserBasicInformation } from 'src/app/_models/users/user-basic-information';
import { UserLogIn } from './../../_models/users/user-login';
import { Router } from '@angular/router';
import { ChangePassword } from 'src/app/_models/users/change-password';
import { SystemUserType } from 'src/app/_models/users/system-user-type';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/app.settings';
import { MainFiltersService } from '../main-filters.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  // Global Array to push auditors ( Remove when call backend)

  selectedUserId: string;

  auditorsData: UserBasicInformation[] = [];
  //
  private url: string;
  private loginUrl: string;
  //
  private addUserUrl: string;
  private getUserByIdUrl: string;
  private updateUserUrl: string;
  private deleteUserUrl: string;
  private blockUserUrl: string;
  private unBlockUserUrl: string;
  private userStatisticsUrl: string;
  private occupiedSeatsUrl: string;
  private getAllUsersUrl: string;
  private getStudentsUrl: string;
  private getAllStaffUrl: string;
  private getBirthDayBoardUrl: string;
  private getStudentsByGuardianIdUrl: string;
  private addUserRelationUrl: string;
  private deleteUserRelationUrl: string;
  private addUserHealthRecordUrl: string;
  private getUserHealthRecordUrl: string;
  private deleteUserHealthRecordUrl: string;
  private updateUserHealthRecordUrl: string;
  private getAllSkillsUrl: string;
  private changePasswordUrl: string;
  private getGuardianByStudentUrl: string;
  private uploadProfileImgUrl: string;
  private getUserTypesUrl: string;
  private addUserTypeUrl: string;
  private deleteUserTypeUrl: string;
  private updateUserTypeUrl: string;
  private addUserTypeRoleUrl: string;
  private deleteUserTypeRoleUrl: string;
  private getAllRolesUrl: string;
  private getRolesIdsByUserTypeUrl: string;
  private getUserTypesBySchoolIdUrl: string;
  private getModuleGroupRolesUrl: string;
  private getDefaultUserSchoolUrl: string;
  private getUserTypesBySchholUserIdUrl: string;
  private getNamesRoleByUserTypeUrl: string;
  private getSchoolUserTYpesByUserIdUrl: string;
  private deleteStaffMemberSchoolUrl: string;
  private updateStaffMemberSchoolUrl: string;
  private addStaffMemberSchoolUrl: string;
  private checkStudentLinkedWithGuardianUrl: string;
  private getGuardiansUrl: string;
  private getAvailableStaffAuditorBySchoolIdUrl: string;
  private getUserTypesByCompanyUrl: string;
  private updateUserMedicalNoteUrl: string;
  private updateUserBloodGroupUrl: string;
  private AddStaffMemberClassUrl: string;
  private getUserClassesIdsUrl: string;
  private updateStaffMemberClassUrl: string;
  constructor(
    public http: HttpClient,
    private router: Router,
    private svcFilter: MainFiltersService,
    private translate: TranslateService,
    private appSettings: AppSettings
  ) {
    this.url = `${environment.apiUrl}Users/`;
    this.addUserUrl = `${this.url}AddUser`;
    this.getUserByIdUrl = `${this.url}GetUserById`;
    this.updateUserUrl = `${this.url}UpdateUser`;
    this.deleteUserUrl = `${this.url}DeleteUser`;
    this.blockUserUrl = `${this.url}BlockUser`;
    this.unBlockUserUrl = `${this.url}UnBlockUser`;
    this.userStatisticsUrl = `${this.url}GetUserStatistics`;
    this.occupiedSeatsUrl = `${this.url}GetOccupiedSeatBySectionId`;
    this.getAllUsersUrl = `${this.url}GetUsers`;
    this.getStudentsUrl = `${this.url}GetStudents`;
    this.getAllStaffUrl = `${this.url}GetAllStaffMember`;
    this.getBirthDayBoardUrl = `${this.url}GetStudentBirthDayBoard`;
    this.getStudentsByGuardianIdUrl = `${this.url}GetStudentsByGuardianId`;
    this.addUserRelationUrl = `${this.url}AddUserRelation`;
    this.deleteUserRelationUrl = `${this.url}DeleteUserRelation`;
    this.addUserHealthRecordUrl = `${this.url}AddUserHealthRecord`;
    this.getUserHealthRecordUrl = `${this.url}GetUserHealthRecordByUserId`;
    this.deleteUserHealthRecordUrl = `${this.url}DeleteUserHealthRecord`;
    this.updateUserHealthRecordUrl = `${this.url}UpdateUserHealthRecord`;
    this.getAllSkillsUrl = `${this.url}GetAllSkills`;
    this.loginUrl = `${environment.apiUrl}Account/login`;
    this.changePasswordUrl = `${environment.apiUrl}Account/ChangePassword`;
    this.getGuardianByStudentUrl = `${this.url}GetGuardianByStudent`;
    this.uploadProfileImgUrl = `${this.url}UploadProfileImage`;
    this.getUserTypesUrl = `${this.url}GetAllSystemUserType`;
    this.addUserTypeUrl = `${this.url}AddUserType`;
    this.deleteUserTypeUrl = `${this.url}DeleteSystemUserType`;
    this.updateUserTypeUrl = `${this.url}UpdateUserSystemType`;
    this.addUserTypeRoleUrl = `${this.url}AddUserTypeRole`;
    this.deleteUserTypeRoleUrl = `${this.url}DeleteUserTypeRole`;
    this.getAllRolesUrl = `${environment.apiUrl}Account/GetAllRoles`;
    this.getRolesIdsByUserTypeUrl = `${this.url}GetRolesIdsByUserTypeId`;
    this.getUserTypesBySchoolIdUrl = `${this.url}GetUserTypesBySchoolId`;
    this.getModuleGroupRolesUrl = `${this.url}GetModuleGroupRoles`;
    this.getDefaultUserSchoolUrl = `${this.url}GetDefaultUserSchool`;
    this.getUserTypesBySchholUserIdUrl = `${this.url}GetUserSchoolUserTypes`;
    this.getNamesRoleByUserTypeUrl = `${this.url}GetRolesNameByUserTypeId`;
    this.getSchoolUserTYpesByUserIdUrl = `${this.url}GetSchoolWithUserType`;
    this.deleteStaffMemberSchoolUrl = `${this.url}DeleteStaffMemberSchool`;
    this.updateStaffMemberSchoolUrl = `${this.url}UpdateStaffMemberSchool`;
    this.addStaffMemberSchoolUrl = `${this.url}AddStaffMemberSchool`;
    this.checkStudentLinkedWithGuardianUrl = `${this.url}GetStudentIsLinkedWithGuardian`;
    this.getGuardiansUrl = `${this.url}GetGuardians`;
    this.getAvailableStaffAuditorBySchoolIdUrl = `${this.url}GetAvailableStaffAuditorBySchoolId`;
    this.getUserTypesByCompanyUrl = `${this.url}GetUserTypesByCompanyId`;
    this.updateUserMedicalNoteUrl = `${this.url}UpdateUserMedicalNote`;
    this.updateUserBloodGroupUrl = `${this.url}ChangeUserBloodGroup`;
    this.AddStaffMemberClassUrl = `${this.url}AddStaffMemberClass`;
    this.getUserClassesIdsUrl = `${this.url}GetUserClassesId`;
    this.updateStaffMemberClassUrl = `${this.url}UpdateStaffMemberClass`;
  }
  // add user
  public addUser(
    pi: PersonalInformation,
    co?: ContactDetails,
    ac?: AcademicDetails,
    sk?: SkillsSocialDetails,
    pa?: ParentDetails,
    iden?: IdentityDetails,
    schoolDetail?: SchoolUserTypeDetail
  ): Observable<any> {
    return this.http.post(this.addUserUrl, this.bindingUserModel(pi, ac, co, sk, pa, iden, null, schoolDetail));
  }

  // get user by id
  getUserById(userId: string) {
    return this.http.get(`${this.getUserByIdUrl}?userId=${userId}`);
  }

  // update user

  updateUser(
    pi: PersonalInformation,
    co?: ContactDetails,
    ac?: AcademicDetails,
    sk?: SkillsSocialDetails,
    pa?: ParentDetails,
    iden?: IdentityDetails,
    profileImg?: string,
    schoolDetail?: SchoolUserTypeDetail
  ) {
    return this.http.put(this.updateUserUrl, this.bindingUserModel(pi, ac, co, sk, pa, iden, profileImg, schoolDetail));
  }

  // delete user
  deleteUser(ids: string[]) {
    return this.http.put(this.deleteUserUrl, ids);
  }
  // un block user
  unBlockUser(ids: string[]) {
    return this.http.put(this.unBlockUserUrl, ids);
  }
  // block user
  blockUser(ids: string[]) {
    return this.http.put(this.blockUserUrl, ids);
  }
  // get user statistics
  getUserStatistics() {
    return this.http.get(this.userStatisticsUrl);
  }

  // get Occupied Seats Number For section
  getOccupiedSeat(sectionId: number) {
    return this.http.get(`${this.occupiedSeatsUrl}?sectionId=${sectionId}`);
  }

  // getUsers
  getUsers(pageIndex: number, pageSize: number, userType?: number, userName?: string) {
    const user = userName != null || userName !== undefined ? userName : '';
    return this.http.get(
      `${this.getAllUsersUrl}?pageIndex=${pageIndex}&pageSize=${pageSize}&userType=${userType ? userType : ''}&userName=${user}`
    );
  }

  // get students
  getStudents(
    pageIndex: number,
    pageSize: number,
    classId?: number,
    sectionId?: number,
    studentName?: string,
    statusId?: string,
    isHasClass: boolean = true
  ) {
    const s = sectionId != null || sectionId !== undefined ? sectionId : '';
    const c = classId != null || classId !== undefined ? classId : '';
    const stName = studentName ? studentName : '';
    return this.http.get(
      `${
        this.getStudentsUrl
        // tslint:disable-next-line:max-line-length
      }?pageIndex=${pageIndex}&pageSize=${pageSize}&classId=${c}&sectionId=${s}&studentName=${stName}&statusId=${statusId}&isHasClass=${isHasClass}`
    );
  }
  getStudentsByName(
    pageIndex: number,
    pageSize: number,
    studentName?: string,
    isHasClass: boolean = true
  ): Observable<PagedResult<UserBasicInformation>> {
    return this.http.get<PagedResult<UserBasicInformation>>(
      `${this.getStudentsUrl}?pageIndex=${pageIndex}&pageSize=${pageSize}&studentName=${studentName}&isHasClass=${isHasClass}`
    );
  }

  getStudentsBySectionId(sectionId: number): Observable<UserBasicInformation[]> {
    return this.http.get<UserBasicInformation[]>(`${this.url}/GetStudentsBySectionId/${sectionId}`);
  }
  $getStudentsBySectionId(sectionId: number) {
    return this.http.get(`${this.url}/GetStudentsBySectionId/${sectionId}`);
  }

  getGuardiansBySectionId(sectionId: number) {
    return this.http.get(`${this.url}/GetGuardiansBySection/${sectionId}`);
  }
  GetStaffUsers(userType: number) {
    return this.http.get(`${this.url}/GetStaffUsers/${userType}`);
  }

  getStudentsBySectionsIds(sectionIds: number[]): Observable<UserBasicInformation[]> {
    return this.http.post<UserBasicInformation[]>(`${this.url}/GetStudentsBySectionsIds`, sectionIds);
  }

  // get All staff
  getAllStaff(pageIndex: number, pageSize: number) {
    return this.http.get(`${this.getAllStaffUrl}?pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }

  // get student birthDay Board
  getBirthDayBoard(pageIndex: number, pageSize: number, currentDay: boolean) {
    return this.http.get(`${this.getBirthDayBoardUrl}?pageIndex=${pageIndex}&pageSize=${pageSize}&currentDay=${currentDay}`);
  }
  // get students by parent Id
  getStudentsByParentId(guardianId: string) {
    return this.http.get(`${this.getStudentsByGuardianIdUrl}/${guardianId}`);
  }
  // add user relation
  addUserRelation(data: UserRelation) {
    return this.http.post(this.addUserRelationUrl, data);
  }
  // delete user relation
  deleteUserRelation(userId: string, studentId: string) {
    return this.http.delete(`${this.deleteUserRelationUrl}/${userId}/${studentId}`);
  }
  // add user health record
  addUserHealthRecord(data: UserHealthRecord) {
    return this.http.post(`${this.addUserHealthRecordUrl}`, data);
  }
  // get user health records by user id
  getUserHealthRecordsByUserId(pageIndex: number, pageSize: number, userId: string, testType?: number) {
    const type = testType != null && testType !== undefined ? testType : '';
    return this.http.get(`${this.getUserHealthRecordUrl}/${pageIndex}/${pageSize}/${userId}?testType=${type}`);
  }
  // delete user health record
  deleteUserHealthRecord(userHealthRecordId: number) {
    return this.http.delete(`${this.deleteUserHealthRecordUrl}/${userHealthRecordId}`);
  }
  // update user health record
  updateUserHealthRecord(data: UserHealthRecord) {
    return this.http.put(`${this.updateUserHealthRecordUrl}`, data);
  }
  //
  getAllSkills() {
    return this.http.get(this.getAllSkillsUrl);
  }

  // handle login
  login(userLogin: UserLogIn) {
    return this.http.post(this.loginUrl, userLogin);
  }
  logOut() {
    return this.http.post(`${environment.apiUrl}Account/logout`, null);
  }
  // handle logout

  logoutReset(): void {
    localStorage.clear();
    if (this.appSettings.settings.rtl) this.translate.use('ar');
    else this.translate.use('en');
    localStorage.setItem('lang', this.translate.currentLang);
    this.router.navigate(['Login']);
    this.svcFilter.deleteMainFilter();
  }
  // change password
  changePassword(data: ChangePassword) {
    return this.http.put(this.changePasswordUrl, data);
  }
  // get guardian by student id
  getGuardianByStudentId(studentId: string) {
    return this.http.get(`${this.getGuardianByStudentUrl}/${studentId}`);
  }

  // handle upload profile image
  uploadProfileImage(userId: string, userType: number, img: File) {
    const data = new FormData();
    data.append('profileImgFile', img);
    data.append('userId', userId);
    data.append('userType', userType.toString());
    return this.http.post(this.uploadProfileImgUrl, data);
  }
  // get user types
  getUserTypes() {
    return this.http.get(this.getUserTypesUrl);
  }

  // Add User Type
  addUserType(data: SystemUserType) {
    return this.http.post(this.addUserTypeUrl, data);
  }

  // update User Type
  updateUserType(data: SystemUserType, roleIds: string[]) {
    const model = {
      systemUserType: data,
      roleIds: roleIds
    };
    return this.http.put(this.updateUserTypeUrl, model);
  }
  // delete user type
  deleteUserType(userTypeId: number) {
    return this.http.delete(`${this.deleteUserTypeUrl}/${userTypeId}`);
  }

  // add user type role
  addUserTypeRole(data: SystemUserType, roleIds: string[]) {
    const model = {
      systemUserType: data,
      roleIds: roleIds
    };
    return this.http.post(this.addUserTypeRoleUrl, model);
  }

  // delete User Type Role
  deleteUserTypeRole(userTypeRoleId: number) {
    return this.http.delete(`${this.deleteUserTypeRoleUrl}/${userTypeRoleId}`);
  }
  // get all roles
  getAllRoles() {
    return this.http.get(this.getAllRolesUrl);
  }
  // get roles Ids By user Type
  getRolesIdsByUserType(userTypeId: number) {
    return this.http.get(`${this.getRolesIdsByUserTypeUrl}/${userTypeId}`);
  }

  // get user types By ProgramId
  getUserTypesBySchoolId(schoolId: number, withPredefined: boolean = false) {
    return this.http.get(`${this.getUserTypesBySchoolIdUrl}/${schoolId}/${withPredefined}`);
  }

  // get module Group Roles
  getModuleGroupRole() {
    return this.http.get(this.getModuleGroupRolesUrl);
  }

  // get default user school
  getDefaultUserSchool(userId: string, defaultSchool: boolean) {
    return this.http.get(`${this.getDefaultUserSchoolUrl}/${userId}/${defaultSchool}`);
  }
  // get user type by school and user id
  getUserTypesBySchoolUserId(userId: string, schoolId: number) {
    return this.http.get(`${this.getUserTypesBySchholUserIdUrl}/${userId}/${schoolId}`);
  }

  // get list of names roles by user type id
  getListRolesNameByUserTypeId(userTypeId: number) {
    return this.http.get(`${this.getNamesRoleByUserTypeUrl}/${userTypeId}`);
  }
  // get schools and user types by user id
  getSchoolUserTYpesByUserId(userId: string) {
    return this.http.get(`${this.getSchoolUserTYpesByUserIdUrl}/${userId}`);
  }
  // delete staff member school
  deleteStaffMemberSchool(userId: string, schoolId: number) {
    return this.http.delete(`${this.deleteStaffMemberSchoolUrl}/${userId}/${schoolId}`);
  }
  // update staff member School
  updateStaffMemberSchool(userId: string, data) {
    return this.http.put(`${this.updateStaffMemberSchoolUrl}/${userId}`, data);
  }
  // add staff member school
  addStaffMemberSchool(data) {
    return this.http.post(this.addStaffMemberSchoolUrl, data);
  }
  // check if student Linke With guardian
  checkIfStudentLinked(studentId: string) {
    return this.http.get(`${this.checkStudentLinkedWithGuardianUrl}/${studentId}`);
  }
  // get guardians
  getGuardians(pageIndex: number, pageSize: number, userName?: string) {
    const user = userName != null || userName !== undefined ? userName : '';
    return this.http.get(`${this.getGuardiansUrl}?pageIndex=${pageIndex}&pageSize=${pageSize}&userName=${user}`);
  }

  // get available Auditor by school Id
  getAvailableStaffBySchoolId(pageIndex: number, pageSize: number, userTypesId: number[]) {
    return this.http.get(`${this.getAvailableStaffAuditorBySchoolIdUrl}/${pageIndex}/${pageSize}/${userTypesId.join()}`);
  }

  // get user types By company Id
  getUserTypesByCompanyId(companyId: number) {
    return this.http.get(`${this.getUserTypesByCompanyUrl}/${companyId}`);
  }

  // update user medical note
  updateUserMedicalNote(data) {
    return this.http.put(this.updateUserMedicalNoteUrl, data);
  }

  // update user blood group
  updateUserBloodGroup(data) {
    return this.http.put(this.updateUserBloodGroupUrl, data);
  }

  // set roles  based on user type selected (current logged in user)
  setRoles(roles: string[]) {
    localStorage.setItem('roles', JSON.stringify(roles));
  }

  // get active Roles for current logged in user
  getCurrentActiveRoles(): string[] {
    if (localStorage.getItem('roles')) {
      return JSON.parse(localStorage.getItem('roles'));
    }
    return [];
  }
  // get if logged user admin
  isAdmin(): boolean {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      return currentUser['roles'].indexOf('SuperAdmin') > -1;
    }
    return false;
  }
  // get Logged in user information
  getLoggedInUserInformation() {
    return JSON.parse(localStorage.getItem('currentUser'));
  }
  // get current loggedIn  user  school
  getCurrentLoggedInSchools() {
    if (localStorage.getItem('schools')) {
      return JSON.parse(localStorage.getItem('schools'));
    }
    return [];
  }
  // helper method to mapper user model
  private bindingUserModel(
    pi: PersonalInformation,
    ac?: AcademicDetails,
    co?: ContactDetails,
    sk?: SkillsSocialDetails,
    pa?: ParentDetails,
    iden?: IdentityDetails,
    profImg?: string,
    schoolDetail?: SchoolUserTypeDetail
  ) {
    const userObj = new GeneralUserData();
    // academicDetails
    if (ac) {
      userObj.classId = ac.classId;
      userObj.sectionId = ac.sectionId;
      userObj.rollNumber = ac.rollNumber;
      userObj.academicYearId = ac.academicYearId;
      userObj.educationalProgramId = ac.educationalProgramId;
      userObj.schoolId = ac.schoolId;
      userObj.academicProgramId = ac.academicProgramId;
    }
    // contact detail
    if (co) {
      userObj.email = co.email;
      userObj.phoneNumber = co.phoneNumber;
      userObj.address = co.address;
      userObj.city = co.city;
      userObj.zipCode = co.zipCode;
    }
    // personal info
    if (pi) {
      userObj.id = pi.id;
      userObj.birthDate = pi.birthDate;
      userObj.genderId = pi.genderId;
      userObj.bloodGroupId = pi.bloodGroupId;
      userObj.firstName = pi.firstName;
      userObj.secondName = pi.secondName;
      userObj.thirdName = pi.thirdName;
      userObj.lastName = pi.lastName;
      userObj.firstNameEn = pi.firstNameEn;
      userObj.secondNameEn = pi.secondNameEn;
      userObj.thirdNameEn = pi.thirdNameEn;
      userObj.lastNameEn = pi.lastNameEn;
      userObj.userTypeId = pi.userType;
      userObj.isDeleted = pi.isDeleted;
      userObj.statusId = pi.statusId;
      userObj.specialNeeds = pi.specialNeeds;
      userObj.height = pi.height;
      userObj.weight = pi.weight;
      userObj.placeOfBirth = pi.placeOfBirth;
      userObj.religionId = pi.religionId;
      userObj.languagesIds = pi.languagesIds;
    }
    // skills and social
    if (sk) {
      userObj.skillsIds = sk.skillIds;
      userObj.facebookUrl = sk.facebookUrl;
      userObj.linkedinUrl = sk.linkedinUrl;
      userObj.twitterUrl = sk.twitterUrl;
      userObj.newSkills = sk.newSkills;
    }
    // parent details
    if (pa) {
      userObj.motherName = pa.motherName;
      userObj.motherEmail = pa.motherEmail;
      userObj.motherPhoneNumber = pa.motherPhoneNumber;
      userObj.fatherName = pa.fatherName;
      userObj.fatherEmail = pa.fatherEmail;
      userObj.fatherPhoneNumber = pa.fatherPhoneNumber;
      userObj.sonWorkers = pa.sonWorkers;
      userObj.guardianId = pa.guardianId;
    }
    if (iden) {
      userObj.nationalityId = iden.nationalityId;
      userObj.idNo = iden.idNo;
      userObj.idType = iden.idType;
      userObj.idExpiryDate = iden.idExpiryDate;
      userObj.idIssueDate = iden.idIssueDate;
    }
    if (profImg) {
      userObj.profileImg = profImg;
    }
    if (schoolDetail) {
      userObj.userSchoolId = schoolDetail.schoolId;
    }
    return userObj;
  }

  getAuditors() {
    return this.http.get('assets/api/users.json');
  }

  // Honor Roll Settings

  GetStudentsByAssignedHonorSettingId(settingId: number) {
    return this.http.get(`${this.url}GetStudentsByAssignedHonorSettingId/${settingId}`);
  }
  // Start Teacher Subject Allocation
  GetAllSubjectsAllocationByUserId(teacherId: string) {
    return this.http.get(`${this.url}GetTeacherAllocationSettings/${teacherId}`);
  }
  CreateSubjectsAllocation(subjectsAllocation: SubjectsAllocation) {
    return this.http.post(`${this.url}CreateTeacherAllocationSettings`, subjectsAllocation);
  }
  UpdateSubjectsAllocation(subjectsAllocation: SubjectsAllocation) {
    return this.http.put(`${this.url}UpdateTeacherAllocationSettings`, subjectsAllocation);
  }

  DeleteTeacherAllocationSettings(subjectsAllocation: SubjectsAllocation) {
    return this.http.delete(`${this.url}DeleteTeacherAllocationSettings/${subjectsAllocation.teacherAllocationSettingId}`);
  }
  // End Teacher Subject Allocation
  // Start Assign Teachers With Subjects
  GetAllTeacherBySubject(subjectId: number) {
    return this.http.get(`${this.url}GetAllTeacherBySubject/${subjectId}`);
  }
  GetAllTeacherBySectionSubject(sectionSubjectId: number) {
    return this.http.get(`${this.url}GetAllTeacherBySectionSubject/${sectionSubjectId}`);
  }
  linkTeachersWithSubject(subjectId:number, teacherIds:string[])
  {
    let obj =
    {
      "subjectId": subjectId,
      "teacherIds":teacherIds
    }
    return this.http.post(`${this.url}LinkTeachersWithSubject`, obj);
  }
  deleteTeachersFromSubject(teacherId:string , subjectId:number)
  {
    return this.http.delete(`${this.url}DeleteTeachersFromSubject/${teacherId}/${subjectId}`);
  }
  // End Assign Teachers With Subjects

  AddStaffMemberClass(data: StaffMemberClass) {
    return this.http.post(`${this.AddStaffMemberClassUrl}`, data);
  }

  getUserClassesIds(userId: string, schoolId: number, userTypeId: number, educationalProgramId: number) {
    return this.http.get(`${this.getUserClassesIdsUrl}/${userId}/${schoolId}/${userTypeId}/${educationalProgramId}`);
  }

  updateStaffClasses(data: StaffMemberClass) {
    return this.http.put(`${this.updateStaffMemberClassUrl}`, data);
  }
  getStudentsBySectionSubjectId(sectionSubjectId: number): Observable<UserBasicInformation[]> {
    return this.http.get<UserBasicInformation[]>(`${this.url}GetStudentsBySectionSubjectId?sectionSubjectId=${sectionSubjectId}`);
  }

  getProfile() {
    return this.http.get(`${this.url}GetProfile`);
  }

  updateProfile(data)  {
    return this.http.put(`${this.url}UpdateProfile`,data);
  }
}
